import { useState } from 'react'
import Modal from 'Shared/components/Modal/Modal'
import AsyncSelect from 'Shared/components/AsyncSelect'
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'

export default function CompleteGoalModal({ open, onCancel, onConfirm }) {
  const [effortId, setEffortId] = useState(null)

  return (
    <Modal
      open={open}
      title="Complete a goal for this audience"
      onCancel={onCancel}
    >
      <div className="row">
        <div className="field">
          <label className="bold margin-bottom">Goal:</label>
          <AsyncSelect
            entity="effort"
            menuPosition="fixed"
            value={effortId}
            loadStaticList={true}
            onChange={(v) => setEffortId(v)}
          />
        </div>
      </div>
      <div className="row">
        <ServerWaitButton
          className="button primary margin-top"
          onClick={() => onConfirm({ effortId })}
        >
          Confirm
        </ServerWaitButton>
      </div>
    </Modal>
  )
}
